import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=98c1c206&"
import script from "./Issues.vue?vue&type=script&lang=js&"
export * from "./Issues.vue?vue&type=script&lang=js&"
import style0 from "./Issues.vue?vue&type=style&index=0&id=98c1c206&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98c1c206')) {
      api.createRecord('98c1c206', component.options)
    } else {
      api.reload('98c1c206', component.options)
    }
    module.hot.accept("./Issues.vue?vue&type=template&id=98c1c206&", function () {
      api.rerender('98c1c206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/hotels/hotel/Issues.vue"
export default component.exports